export type RedesignBucket = "blunder" | "normal";
export type RedesignBucketFilter = "all" | RedesignBucket;

const BLUNDER_CATEGORIES = new Set([
  "design mistake",
  "note missed",
  "files mistake",
  "file mistake",
  "client preference missed",
  "minor design mistake",
]);

export const splitCategoryLabels = (raw?: string | null) =>
  String(raw || "")
    .split(",")
    .map((part) => part.replace(/\s+/g, " ").trim())
    .filter(Boolean);

const normalizeCategory = (label: string) =>
  label.replace(/\s+/g, " ").trim().toLowerCase();

export const isBlunderCategory = (label: string) =>
  BLUNDER_CATEGORIES.has(normalizeCategory(label));

/** Blunder if any label is a blunder. Otherwise a redesign is Normal (including Others). */
export const redesignBucket = (
  category?: string | null,
  kind?: string | null,
): RedesignBucket | null => {
  const labels = splitCategoryLabels(category);
  const isRedesign =
    kind === "redesign" || kind === "internal_redesign" || labels.length > 0;
  if (!isRedesign) return null;
  if (labels.some(isBlunderCategory)) return "blunder";
  return "normal";
};

export const reasonsAreBlunder = (
  reasons: Array<{ category?: string | null }>,
) =>
  reasons.some((reason) =>
    splitCategoryLabels(reason.category).some(isBlunderCategory),
  );

export const matchesRedesignBucket = (
  filter: RedesignBucketFilter,
  category?: string | null,
  kind?: string | null,
) => {
  if (filter === "all") return true;
  return redesignBucket(category, kind) === filter;
};

/** Live cases with no return stay out of both filters. A blunder reason wins over Normal. */
export const employeeRowBucket = (row: {
  kind?: string | null;
  category?: string | null;
  came_back?: boolean;
  redesigns?: Array<{ category?: string | null }>;
}): RedesignBucket | null => {
  if (row.kind === "live") {
    const reasons = row.redesigns || [];
    if (reasonsAreBlunder(reasons)) return "blunder";
    if (row.came_back || reasons.length > 0) return "normal";
    return null;
  }
  return redesignBucket(row.category, row.kind);
};
